import React from 'react';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Typography from '@mui/material/Typography';


const DeleteElementDialog = ({ open, niveau, code, libelle, parametre, onDeleteElement, onClose }) => {

    const handleCancel = () => {
        onClose();
    };

    const handleDelete = () => {
        onClose();
        onDeleteElement(niveau, code, parametre);
    };

    return (
        <Dialog open={open}>

            <DialogTitle>
                Suppression du paramètre "{parametre.libelle}" pour l'élément :
            </DialogTitle>

            <DialogContent dividers>

                <Typography component='div' variant="subtitle1" gutterBottom>
                    Niveau :
                    <Box fontWeight='500' display='inline'> {niveau}</Box>
                </Typography>

                <Typography component='div' variant="subtitle1" gutterBottom>
                    Code :
                    <Box fontWeight='500' display='inline'> {code}</Box>
                </Typography>

                <Typography component='div' variant="subtitle1" gutterBottom>
                    Libellé :
                    <Box fontWeight='500' display='inline'> {libelle}</Box>
                </Typography>

            </DialogContent>

            <DialogActions>
                <Button
                    variant="standard"
                    color="primary"
                    onClick={handleCancel}
                >
                    Annuler
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleDelete}
                >
                    Supprimer
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default DeleteElementDialog;


